import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DeleteModal from "./DeleteModal";
import ListAdminButtons from "../Common/ListAdminButtons";
import { useTranslation } from "react-i18next";

import { priceListServices } from "../../Services";

const PriceList = () => {
  const { t: translator } = useTranslation();
  const history = useHistory();

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [priceLists, setPriceLists] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filters, setFilters] = useState({
    searchName: "",
  });

  useEffect(() => {
    priceListServices
      .getSearch({
        tenantId: 1,
        searchName: filters.searchName,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((data) => {
        setPriceLists(data.data.priceLists);
      });
  }, [pagination, filters]);

  useEffect(() => {}, [priceLists]);

  const handleToAdd = () => {
    history.push("/add-price-list");
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/edit-price-list/${selectedItems}`);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((id) => {
      deletePromises.push(priceListServices.deletePriceList(id));
    });

    Promise.all(deletePromises).then((data) => {
      setUpdate(new Date());
      setShowDeleteModal(false);
    });
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.priceListId]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.priceListId));
    }
  };

  const handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      setSelectedItems(priceLists.map((x) => x.priceListId));
    } else {
      setSelectedItems([]);
    }
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/edit-price-list/${row.priceListId}`);
      }
    },
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="priceListId"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={selectedItems.find((x) => x === row.priceListId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={
              priceLists &&
              priceLists.length > 0 &&
              !priceLists
                .map((p) => p.priceListId)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const columns = [
    {
      dataField: "priceListId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
    },
    {
      dataField: "name",
      text: translator("PriceList-View-Name"),
      sort: true,
    },
  ];

  return (
    <div className="p-2">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("PriceList-View-Subtitle")}</span>
          <button className="btn btn-primary float-right" onClick={handleToAdd}>
            {" "}
            <span
              className="icon icon-cancel web-hidden"
              style={{ transform: "rotate(45deg)" }}
            ></span>
            {translator("PriceList-View-AddPriceList")}
          </button>
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("PriceList-View-Filters")}
            </legend>
            <form className="row">
              <div className="form-group col-lg-4">
                <label>{translator("PriceList-View-Filters-Name")}</label>
                <input
                  name="searchName"
                  type="text"
                  className="form-control"
                  defaultValue={filters.searchName}
                  onChange={handleInputChange}
                />
              </div>
            </form>
          </fieldset>
          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToDetail={() => console.log("handleToDetail")}
            handleToUpdate={handleToUpdate}
            handleDelete={() => setShowDeleteModal(true)}
          />
          <RemoteAll
            data={priceLists}
            page={pagination.pageIndex + 1}
            sizePerPage={pagination.pageSize}
            totalSize={pagination.totalCount}
            onTableChange={handleTableChange}
          />
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("PriceList-DeleteModal-Title")}
        text={translator("PriceList-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />
    </div>
  );
};

export default PriceList;
